var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrapper",class:{ 'header-selected': _vm.isSelected },on:{"click":_vm.handleClick}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }